<template>
<div class="stretch-vertical">
    <b-navbar toggleable="xl" type="light" variant="light" style="border-bottom: 2px solid #2C3D47">
        <b-navbar-brand :to="{ name: 'home' }">
            <img src="@/assets/HLS-logo.svg" class="top-logo" />
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav v-show="loggedIn">
                <div v-for="tab in tabs" :key="tab.Id">
                    <b-nav-item-dropdown :text="tab.Name" v-if="tab.Children.length > 0">
                        <div v-for="sub in tab.Children" :key="sub.Id">
                            <b-dropdown-item :to="{ name: sub.Id }" v-show="sub.Children.length === 0">
                                {{ sub.Name }}
                            </b-dropdown-item>
                            <nav-item-tree :tab="sub"></nav-item-tree>
                        </div>
                    </b-nav-item-dropdown>
                     <b-nav-item v-else :to="{ name: tab.Id }">{{ tab.Name }}</b-nav-item>
                </div>
            </b-navbar-nav>
            
            <div v-on:mouseleave="showSuggestions = false" style="margin: auto">
                <div v-show="loggedIn" class="input-group input-group-sm">
                    <input v-on:click="openSuggestions" v-on:keyup.enter="gotoSearch(searchText)" v-model="searchText" style="width: 250px" autocomplete="off"
                        class="form-control" type="search" name="q" aria-label="Search" >
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="gotoSearch(searchText)"><i class="fa fa-search" aria-hidden="true"></i></button>
                        </div>
                </div>
                <div v-show="showSuggestions" style="background: white; border: 1px solid #ced4da; position: absolute; width: 250px; font-size: 0.9em">
                    <a href="#" class="dropdown-item" v-for="(item, index) in suggestions" :key="index" :value="item" @click="gotoSearch(item)">
                        {{ item }}
                    </a>
                </div>
            </div>

            <b-navbar-nav class="ml-auto">
                <b-nav-item v-show="!loggedIn" class="nav-link" :to="{ name: 'Login' }">Login</b-nav-item>
                
                <b-nav-item-dropdown text="Admin" v-if="loggedIn && admin">
                    <b-dropdown-item :to="{ name: 'ManageUsers' }" v-if="admin">
                        Manage Users
                    </b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'PageEditor' }" v-if="admin">
                        Manage Contents
                    </b-dropdown-item>
                     <b-dropdown-item :to="{ name: 'SearchLog' }" v-if="admin">
                        Search Log 
                    </b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown v-show="loggedIn" v-bind:text="user" right>
                    <b-dropdown-item :to="{ name: 'ResetPasswordLoggedIn' }">
                        Reset Password
                    </b-dropdown-item>
                    <b-dropdown-item v-on:click="logOut" href="javascript:void(0);">
                        Log Out
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>

    <div v-show="loggedIn && isContentPage()" class="toolbar">
        <div class="toolbar-label">Quick Links</div>
        <div class="btn-group-vertical">
            <a class="icon-btn" title="Payment Form" href="https://www.tfaforms.com/4906816" target="_blank">
                <i class="fa fa-fw fa-usd"></i><div class="icon-label">Make a Payment</div>
            </a>
            <a class="icon-btn" title="Maintenance Request Form" href="https://www.tfaforms.com/4888046" target="_blank">
                <i class="fa fa-fw fa-wrench"></i><div class="icon-label">Maintenance Requests</div>
            </a>
            <a class="icon-btn" title="Feedback Form" href="https://www.tfaforms.com/4889991" target="_blank">
                <i class="fa fa-fw fa-comment"></i><div class="icon-label">Provide Feedback</div>
            </a>
        </div>
    </div>

    <router-view class="stretch-vertical" style="overflow:auto"/>

    <div class="bg-dark footer container-fluid align-items-center">
        <span>&copy;  {{ new Date().getFullYear() }} amentum</span>
        <div style="display:inline; margin-left: 2em;" class="dropdown housing-mode-dropdown" v-if="loggedIn && (servicesUser || admin)">
            <a href='tel:+61(0)889513500' class='search-link'>P: +61 (0)8 8951 3500  </a>
            <a href='mailto:hls@jdfpg.net' class='search-link'>E: hls@jdfpg.net</a>
        </div>
        <img width="80px" class="float-right" src="@/assets/amentum-logo.svg" alt="Amentum logo">
    </div>
</div>
</template>

<script>
import axios from 'axios';
import router from '././router';
import {TokenService} from './services/token.service';
import {RoleService} from './services/role.service';
import NavItemTree from './components/NavItemTree.vue';

export default {
    /* eslint-disable */
    data() {
        return {
            loggedIn: false,
            admin: false,
            servicesUser: false,
            user: '',
            roles: '',
            inEditorRole: false,
            routeRoot: '',
            logoType: '',
            searchText: '',
            suggestions: [],
            showSuggestions: false,

            tabs: []
        }
    },
    components: {
        NavItemTree
    },
    watch: {
        searchText: function(search) {
            const vm = this;
            axios.post('/api/searches/10', { text: search }).then(response => {
                vm.suggestions = response.data.map(o => o.Text);
            })
            .catch(error => { 
                vm.suggestions = [];
            });
        }
    },
    created: function() {
        axios.get('/api/webtabs/tree').then(res => {
            this.tabs = res.data.filter(o => o.Name !== 'Home');
        });
    },
    mounted: function () {
        const vm = this;
        // Login event to update the main page menu
        this.$on('login', function (value) {
            // moved role logic into this method to be called here and later down in 'mounted' method
            vm.setRoles();
        });

        // Event to set user as logged out if there's no token
        this.$on('noToken', function() {
            vm.setLoggedOut();
        });

        $('.nav-link').on('click', function (e) {
            $(this).next(".dropdown-menu").find('.dropdown-menu.show').each(function() {
                $(this).toggleClass('show');
            });
        });

        // moved roles logic into here...housing stuff wasn't getting set when refreshing the page
        this.setRoles();
    },
    methods: {
        /**
         * Moved logic that was being set on $.on('login) and the mounted function into this one function
         * to be called in both places. When refreshing the page some housing mode code wasn't getting called.
         */
        setRoles: function() {
            this.checkLoggedIn();
            this.roles = TokenService.getRoles();
            this.user = TokenService.getUserName();
            this.admin = RoleService.isAdmin();
            this.servicesUser = this.roles.indexOf("ServicesAdmin") >= 0 || this.roles.indexOf("ServicesOfficer") >= 0;
            this.inEditorRole = RoleService.inEditorRole();
        },
        checkLoggedIn: function () {
            if (TokenService.getToken()) {
                this.loggedIn = true;
            } else {
                this.loggedIn = false;
            }
        },
        setLoggedOut: function() {
            TokenService.removeToken();
            this.loggedIn = false;
            this.admin = false;
        },
        logOut: function () {
            this.setLoggedOut();
            location.reload();
        },
        isContentPage: function() {
            return this.$route.meta.isContent === true;
        },

        cancelSearch: function() {
            this.searchText = '';
        },
        gotoSearch: function(text) {
            const vm = this;
            
            if (text == '') {
                return;
            }

            router.push({ name: 'search', params: { text: text } });
        },
        openSuggestions: function() {
            const vm = this;
            vm.showSuggestions = true;
            axios.post('/api/searches/10', { text: vm.searchText }).then(response => {
                vm.suggestions = response.data.map(o => o.Text);
            })
            .catch(error => { 
                vm.suggestions = [];
            });
        }
    }
}
</script>

<style>

.toolbar-label {
    font-size: 0.8em;
    font-weight: 600;
    text-align: center;
    background: #fff;
    padding: 4px;
}

.toolbar {
    position: absolute !important;
    top: 32%;
    left: 13px;
    border: 1px solid #2C3D47;
    width: 66px;
}

.icon-btn {
    background: #2C3D47;
    color: #fff;
    text-align: center;
    width: 65px;
    padding: 6px 4px;
    border: 1px solid #2C3D47;
}

.icon-btn:hover {
    background: #23272b;
    color: #eee;
    text-decoration: none;
    border-bottom: 1px solid #eee;
}

.icon-label {
    font-size: 0.6em;
}

.search-link {
    color: white;
    margin-left: 1em;
}

.search-link:hover {
    color: white;
}

.main-menu {
    min-height: 5em;
}

.main-menu .dropdown-submenu a:after {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
    position: absolute;
    right: 6px;
    top: .8em;
}

.main-menu .dropdown-submenu .dropdown-menu {
    top: 0;
    left: 100%;
    margin-left: .1rem;
    margin-right: .1rem;
}

.dropdown-submenu {
    position: relative;
    padding-left: .2em;
}
    
.dropdown li:hover > ul {
    display: block;
}

.brand-container {
    height: 2.5em;
}

.brand-container img {
    height: 100%;
}

.top-logo {
    width: 60px;
    cursor: pointer;
}

.logo-register-col {
    float:none;
    margin:0 auto;
    padding: 0 !important;
}

.logout-link {
    margin-left: 6px; 
}

.housing-mode-dropdown {
    text-align: center;
}

.explore {
    text-align: center;
    margin-top: 10px;
}

.explore .btn-lg,
.explore .btn-lg:hover {
    border-radius: 30px;
    padding: 15px 25px;
    font-size: 22px;
    background-image: none;
    background-color: #18affb;
    border-color: #18affb;
    color: #ffffff;
}

</style>
